import { truthyFilter } from '../../utils/tsUtils';
import { urlDecode } from '../../utils/utils';
import { splitWithBraces, trimBraces } from './inboundUtils';
export const encodedStringParser = (str) => urlDecode(str).trim();
export function encodedStringArrayParser(str) {
    return trimBraces(str).split(',').map(urlDecode);
}
/**
 * Parses an encoded string that contains key/value pairs and two layers of URL-encoding.
 * For example, parses the string "{{k1,v1},{k2,v2}}" where each key and value are URL-encoded, but the entire string
 * is URL-encoded too before being passed to the function.
 */
export function encodedStringRecordParser(encodedStr) {
    return splitWithBraces(trimBraces(urlDecode(encodedStr))).reduce((acc, curr) => {
        const [key, value] = trimBraces(curr).split(',').map(urlDecode);
        acc[key] = value;
        return acc;
    }, {});
}
export const stringParser = (str) => str.trim();
export const booleanParser = (str) => str === '1';
export const numberParser = (str) => Number(str);
/**
 * Converts the numeric input to `undefined` if -1.
 */
export function numberOrUndefinedParser(str) {
    const strAsNumber = numberParser(str);
    return strAsNumber === -1 ? undefined : strAsNumber;
}
export const numberArrayParser = (str) => {
    return trimBraces(str)
        .split(',')
        .filter((numberStr) => numberStr.length) // ignore "empty" numbers
        .map(Number);
};
export function createArrayWithBracesParser(itemParser, removeFalsyItems = false) {
    return function (str) {
        const trimmedStr = trimBraces(str);
        if (!trimmedStr) {
            // after trimming braces, string is empty, so don't attempt to split and parse
            return [];
        }
        const rawArray = splitWithBraces(trimmedStr).map(itemParser);
        return removeFalsyItems ? rawArray.filter(truthyFilter) : rawArray;
    };
}
